import FadeUp from "./FadeUp";
import {
    Search,
    Gift,
    Coins,
    Youtube,
    Camera,
    Cog,
} from "lucide-react";

const items = [
    {
        icon: Search,
        title: "Creator Discovery Engine",
        body: "A repeatable system to surface creators who genuinely influence your ideal users, not just have a following.",
    },
    {
        icon: Gift,
        title: "Product Trial Engine",
        body: "We create a flow to give creators premium access, extended trials, and giveaways that convert into intent-based content.",
    },
    {
        icon: Coins,
        title: "Affiliate Engine",
        body: "Turn creators into recurring acquisition partners with clean tracking and tiered payouts.",
    },
    {
        icon: Youtube,
        title: "YouTube Partnership Engine",
        body: "Long-term integrations with productivity YouTubers that keep sending qualified trials for years, not weeks.",
    },
    {
        icon: Camera,
        title: "UGC Machine",
        body: "A steady, rights-cleared library of creator content your team can repurpose across paid and organic.",
    },
    {
        icon: Cog,
        title: "Creator Operating System",
        body: "Everything documented. Everything repeatable. Everything your team can eventually own without me in the room.",
    },
];

export const WhatIBuild = () => (
    <section
        id="services"
        data-testid="what-i-build-section"
        className="py-24 md:py-32 bg-white"
    >
        <div className="container-page">
            <div className="max-w-3xl">
                <FadeUp>
                    <p className="text-xs font-bold tracking-[0.22em] uppercase text-gray-500">
                        What I build
                    </p>
                </FadeUp>
                <FadeUp delay={0.05}>
                    <h2
                        data-testid="what-i-build-heading"
                        className="mt-4 font-display font-extrabold text-3xl md:text-4xl lg:text-5xl tracking-[-0.02em] leading-[1.4] text-[#0A0A0A] text-balance"
                    >
                        Six systems. One compounding engine.
                    </h2>
                </FadeUp>
                <FadeUp delay={0.1}>
                    <p className="mt-5 text-[15.5px] md:text-base text-gray-600 leading-relaxed max-w-2xl">
                        Each of these works on its own. Together, they become the growth channel your team owns.
                    </p>
                </FadeUp>
            </div>

            <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                {items.map((it, i) => (
                    <FadeUp key={i} delay={0.05 + (i % 3) * 0.05}>
                        <div
                            data-testid={`what-i-build-card-${i}`}
                            className="group h-full rounded-2xl border border-black/[0.08] bg-white p-6 md:p-7 hover:border-black/20 hover:-translate-y-0.5 transition-all"
                        >
                            <div className="inline-flex items-center gap-2 rounded-full bg-[#FAFAFA] border border-black/[0.06] px-3 py-1 text-[11px] font-bold tracking-[0.15em] uppercase text-gray-500">
                                0{i + 1}
                            </div>
                            <div className="mt-5 h-11 w-11 rounded-xl bg-[#0A0A0A] flex items-center justify-center">
                                <it.icon className="h-5 w-5 text-white" strokeWidth={1.8} />
                            </div>
                            <h3 className="mt-5 font-display font-bold text-lg md:text-xl tracking-tight text-[#0A0A0A] leading-[1.3]">
                                {it.title}
                            </h3>
                            <p className="mt-3 text-[14.5px] text-gray-600 leading-relaxed">
                                {it.body}
                            </p>
                        </div>
                    </FadeUp>
                ))}
            </div>
        </div>
    </section>
);

export default WhatIBuild;
